// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
body {
    font-family: "Segoe UI", Roboto, sans-serif;
    margin: 40px auto;
    max-width: 900px;
    padding: 0 20px;
    line-height: 1.6;
    background-color: #f9f9f9;
    color: #333;
}

h1, h2, h3, h4 {
    color: #00457c;
    margin-top: 1.5em;
    margin-bottom: 0.5em;
}

h1 {
    font-size: 2.2em;
    border-bottom: 2px solid #ccc;
    padding-bottom: 5px;
}

h2 {
    font-size: 1.8em;
    border-bottom: 1px solid #ddd;
    padding-bottom: 3px;
}

h3 {
    font-size: 1.5em;
    margin-top: 1em;
}

h4 {
    font-size: 1.2em;
    margin-top: 0.8em;
}

p {
    margin-bottom: 1em;
}

ul {
    padding-left: 1.2em;
    margin-bottom: 1em;
}

li {
    margin-bottom: 0.5em;
}

pre {
    background-color: #fff;
    padding: 20px;
    border-radius: 6px;
    overflow-x: auto;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.doc-score-box {
    background: #fff;
    border-left: 6px solid #3399cc;
    border-right: 6px solid #3399cc;
    margin-bottom: 16px;
    padding: 16px 20px;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
    cursor: pointer;
    transition: box-shadow 0.3s;
}

.doc-score-box:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.header-score {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.status-score-icon {
    font-size: 1.4em;
}

.details-score {
    margin-top: 12px;
    display: none;
}

.doc-score-box.open .details-score {
    display: block;
}

.doc-box {
    background: #fff;
    /* border-left: 6px solid #3399cc; */
    /* border-right: 6px solid #3399cc; */
    margin-bottom: 0px;
    padding: 4px 4px;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
    cursor: pointer;
    transition: box-shadow 0.3s;
}

.doc-box:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.status-icon {
    font-size: 1.4em;
}

.details {
    margin-top: 12px;
    display: none;
}

.doc-box.open .details {
    display: block;
}

ul {
    margin: 8px 0 0 20px;
}

.compliance-score {
    display: block;
    width: 100%;
    background-color: #d4edda; /* Soft green */
    color: #155724;
    border-radius: 6px;
    font-size: 1.2em;
    font-weight: bold;
    box-sizing: border-box;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.compliance-score.low {
    background-color: #f8d7da; /* red background */
    color: #721c24;
}

.compliance-score.medium {
    background-color: #F2B046; /* orange background */
    color: #721c24;
}

.compliance-score.high {
    background-color: #d4edda; /* green background */
    color: #155724;
}`, "",{"version":3,"sources":["webpack://./src/styles/analyze_report.css"],"names":[],"mappings":";AACA;IACI,2CAA2C;IAC3C,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,yBAAyB,EAAE,eAAe;IAC1C,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB,EAAE,mBAAmB;IAC9C,cAAc;AAClB;;AAEA;IACI,yBAAyB,EAAE,sBAAsB;IACjD,cAAc;AAClB;;AAEA;IACI,yBAAyB,EAAE,qBAAqB;IAChD,cAAc;AAClB","sourcesContent":["\nbody {\n    font-family: \"Segoe UI\", Roboto, sans-serif;\n    margin: 40px auto;\n    max-width: 900px;\n    padding: 0 20px;\n    line-height: 1.6;\n    background-color: #f9f9f9;\n    color: #333;\n}\n\nh1, h2, h3, h4 {\n    color: #00457c;\n    margin-top: 1.5em;\n    margin-bottom: 0.5em;\n}\n\nh1 {\n    font-size: 2.2em;\n    border-bottom: 2px solid #ccc;\n    padding-bottom: 5px;\n}\n\nh2 {\n    font-size: 1.8em;\n    border-bottom: 1px solid #ddd;\n    padding-bottom: 3px;\n}\n\nh3 {\n    font-size: 1.5em;\n    margin-top: 1em;\n}\n\nh4 {\n    font-size: 1.2em;\n    margin-top: 0.8em;\n}\n\np {\n    margin-bottom: 1em;\n}\n\nul {\n    padding-left: 1.2em;\n    margin-bottom: 1em;\n}\n\nli {\n    margin-bottom: 0.5em;\n}\n\npre {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 6px;\n    overflow-x: auto;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.doc-score-box {\n    background: #fff;\n    border-left: 6px solid #3399cc;\n    border-right: 6px solid #3399cc;\n    margin-bottom: 16px;\n    padding: 16px 20px;\n    border-radius: 8px;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n    cursor: pointer;\n    transition: box-shadow 0.3s;\n}\n\n.doc-score-box:hover {\n    box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n}\n\n.header-score {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.status-score-icon {\n    font-size: 1.4em;\n}\n\n.details-score {\n    margin-top: 12px;\n    display: none;\n}\n\n.doc-score-box.open .details-score {\n    display: block;\n}\n\n.doc-box {\n    background: #fff;\n    /* border-left: 6px solid #3399cc; */\n    /* border-right: 6px solid #3399cc; */\n    margin-bottom: 0px;\n    padding: 4px 4px;\n    border-radius: 8px;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n    cursor: pointer;\n    transition: box-shadow 0.3s;\n}\n\n.doc-box:hover {\n    box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.status-icon {\n    font-size: 1.4em;\n}\n\n.details {\n    margin-top: 12px;\n    display: none;\n}\n\n.doc-box.open .details {\n    display: block;\n}\n\nul {\n    margin: 8px 0 0 20px;\n}\n\n.compliance-score {\n    display: block;\n    width: 100%;\n    background-color: #d4edda; /* Soft green */\n    color: #155724;\n    border-radius: 6px;\n    font-size: 1.2em;\n    font-weight: bold;\n    box-sizing: border-box;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.compliance-score.low {\n    background-color: #f8d7da; /* red background */\n    color: #721c24;\n}\n\n.compliance-score.medium {\n    background-color: #F2B046; /* orange background */\n    color: #721c24;\n}\n\n.compliance-score.high {\n    background-color: #d4edda; /* green background */\n    color: #155724;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
